// Patches missing accessible names on swatch inputs rendered by the Globo
// Color Swatch app. The app sometimes outputs an <input> with no associated
// label text (e.g. swatches with class `swatch-other`), which fails the
// "form elements have labels" accessibility check.

const SWATCH_INPUT_SELECTOR = 'input[id^="swatch-collection-"]:not([aria-label])';

const deriveLabel = (input) => {
  const label = input.closest('label');
  const candidates = [
    input.value,
    input.getAttribute('title'),
    input.dataset.value,
    input.dataset.title,
    input.dataset.optionValue,
    label?.getAttribute('title'),
    label?.dataset.value,
    label?.querySelector('img')?.alt,
  ];

  for (const candidate of candidates) {
    const text = candidate?.trim();
    if (text) return text;
  }

  return 'Variant option';
};

const labelSwatchInputs = (root = document) => {
  for (const input of root.querySelectorAll(SWATCH_INPUT_SELECTOR)) {
    input.setAttribute('aria-label', deriveLabel(input));
  }
};

const start = () => {
  labelSwatchInputs();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches?.(SWATCH_INPUT_SELECTOR) || node.querySelector?.(SWATCH_INPUT_SELECTOR)) {
          labelSwatchInputs(node.parentElement ?? document);
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start, { once: true });
} else {
  start();
}
